/* istanbul ignore file */
import React from 'react';
import { FilterSection } from 'domain/shared/oneStop';
import Box from '@mui/material/Box';

export type SectionProps = {
  isDesktop: boolean;
  activeFilterId: string;
  requestsList: React.ReactChild;
  handleCategoryClick: (id: string) => void;
};

type OneStopDefaultFilterItemProps = {
  section: FilterSection;
  isIconVisible?: boolean;
  sectionProps: SectionProps;
};

const OneStopDefaultFilterItem = ({ section, sectionProps, isIconVisible = false }: OneStopDefaultFilterItemProps) => {
  const { id, title, icon } = section;
  const { handleCategoryClick, activeFilterId, requestsList, isDesktop } = sectionProps;

  return (
    <>
      <Box component="li">
        <Box
          component="button"
          type="button"
          onClick={() => handleCategoryClick(id)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '14px',
            lineHeight: '14px',
            minHeight: '32px',
            position: 'relative',
            border: 'none',
            borderRadius: 0,
            backgroundColor: activeFilterId === id ? 'background.brandSubtle' : 'transparent',
            color: isIconVisible ? 'primary.main' : 'inherit',
            width: '100%',
            textAlign: 'left',
            outline: 'none',
            padding: '10px 16px',
            marginBottom: isIconVisible ? '0.5rem' : 0,
            fontFamily: 'inherit',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: activeFilterId === id ? 'background.brandSubtle' : 'action.hover',
            },
            '& .MuiSvgIcon-root': {
              marginRight: '7px',
              width: '21px',
              height: '21px',
            },
          }}
        >
          {isIconVisible && icon}
          {title}
        </Box>
      </Box>
      {!isDesktop && activeFilterId === id && requestsList}
    </>
  );
};

export default OneStopDefaultFilterItem;
